import { organizationUserQueryKeys } from "@/api/query-keys/organizations"
import { OrganizationUserCreate } from "@/pages/organisaties/contactpersonen/OrganizationUserCreate"
import { checkPermissions } from "@/utils/checkPermissions"
import { useQueryClient } from "@tanstack/react-query"
import { createFileRoute, useParams, useRouter } from "@tanstack/react-router"
import { FormStyle } from "toptaal-shared"

export const Route = createFileRoute(
  "/beheer/organisaties/$organizationId/contactpersonen/aanmaken",
)({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("create", "contacts"),
})

function RouteComponent() {
  const router = useRouter()
  const queryClient = useQueryClient()

  const { organizationId } = useParams({
    from: "/beheer/organisaties/$organizationId/contactpersonen/aanmaken",
  })

  const handleSuccess = () => {
    queryClient.invalidateQueries({
      queryKey: organizationUserQueryKeys.users(),
    })

    router.navigate({
      to: "/beheer/organisaties/$organizationId/contactpersonen",
      params: { organizationId },
      replace: true,
    })
  }

  return (
    <FormStyle className="mx-auto">
      <h2 className="text-center text-xl mb-8">Nieuw contactpersoon</h2>

      <OrganizationUserCreate
        organizationId={organizationId}
        onSuccess={handleSuccess}
      />
    </FormStyle>
  )
}
